import * as THREE from 'three';

export default class GamutCompress {
	constructor() {
		this.controls = {
			thC: {
				default: 0.15,
				min: 0,
				max: 0.3
			},
			thM: {
				default: 0.15,
				min: 0,
				max: 0.3
			},
			thY: {
				default: 0.15,
				min: 0,
				max: 0.3
			},
			dC: {
				default: 0.1,
				min: 0,
				max: 0.4
			},
			dM: {
				default: 0.2,
				min: 0,
				max: 0.4
			},
			dY: {
				default: 0.1,
				min: 0,
				max: 0.4
			},
			power: {
				default: 1,
				min: 0,
				max: 1
			}
		}
		this.blockName = "gamut-compress";
	}

	addBlock(blockNum = lutify.blocks.length) {
		UI.createAdjustmentBlockTemplate(this.blockName, blockNum);
		let element = UI.getAdjustmentBlock(blockNum);
		UI.removeBlockBlendingModes($(element));

		$(element)
			.find(".btn-reset-block")
			.on("click", e => {
				e.stopPropagation();
				this.resetBlock($(element));
			});

		$(element)
			.find(".expand_options")
			.trigger("click", [false]);

		$(element)
			.find(".range_slider")
			.on("input", e => {
				blocks.checkSwitchHandler($(element));
				this.sliderHandler($(e.currentTarget));
			});

		$(element)
			.find(".range_value")
			.on("change", e => {
				blocks.checkSwitchHandler($(element));
				this.sliderHandler($(e.currentTarget));
			});

		UI.initKnob(element, {
			size: 30,
		});

		blocks.add({
			name: "GamutCompress",
			passes: [this.addPass()],
			blockNum,
			blendingMode: 0,
			blendingModeName: "Normal",
			values: {
				thC: this.controls.thC.default,
				thM: this.controls.thM.default,
				thY: this.controls.thY.default,
				dC: this.controls.dC.default,
				dM: this.controls.dM.default,
				dY: this.controls.dY.default,
				power: this.controls.power.default
			}
		});

		$(element).find('.switch input').trigger('click');
		this.render();
	}

	addPass() {
		let shaderPass = gpu.createGamutCompressShaderPass(this.blockName, true);
		shaderPass.enabled = true;
		gpu.addPassToComposer(shaderPass, "toMiddle");
		return shaderPass;
	}

	resetBlock($element) {
		Object.keys(this.controls).forEach(control => {
			$element.find(`input[type="number"][data-control="${control}"]`).val(this.controls[control].default);
			$element.find(`input[type="number"][data-control="${control}"]`).trigger('change');
		})
	}

	sliderHandler($element) {
		let value = parseFloat($element.val());
		let control = $element.data("control");

		if ($element.hasClass("range_value")) {
			if (value > this.controls[control].max) {
				value = this.controls[control].max;
				$element.val(value);
			}
			if (value < this.controls[control].min) {
				value = this.controls[control].min;
				$element.val(value);
			}
		}

		if ($element.hasClass("range_slider"))
			$element
				.closest(".block-sliders-container")
				.find(".range_value")
				.val(value);
		else
			$element
				.closest(".block-sliders-container")
				.find(".range_slider")
				.val(value);

		lutify.getActiveBlock().values[control] = value;
		this.render();
	}

	render() {
		let pass = lutify.getActiveBlock().passes[0];
		let values = lutify.getActiveBlock().values;
		pass.uniforms.thresholdCMY.value = new THREE.Vector3(values.thC, values.thM, values.thY);
		pass.uniforms.distanceCMY.value = new THREE.Vector3(values.dC, values.dM, values.dY);
		pass.uniforms.power.value = values.power;

		gpu.render();
	}

	applyChanges($block, values) {
		Object.keys(this.controls).forEach(control => {
			$block.find(`input[type="number"][data-control="${control}"]`).val(values[control]);
			$block.find(`input[type="number"][data-control="${control}"]`).trigger('change');
		})
	}
}
